import { render, staticRenderFns } from "./EditMessageTemplate.vue?vue&type=template&id=2865410a&scoped=true"
import script from "./EditMessageTemplate.vue?vue&type=script&lang=js"
export * from "./EditMessageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865410a",
  null
  
)

export default component.exports